import classes from './ReJectetEdit.module.css'
import { onKeyDown } from "../../../../../lms-shared/service.js";
import RemarkEditor from "../RemarkEditor/RemarkEditor.js";
import { submissionsApi } from '../../../../../../utils';
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../../../../../lms-shared/store/error-handling-actions";

const RejectEdit = ({
    setRemarks,
    feedback,
    submissionData,
    setSubmissionData,
    setEditData,
    markAssessmentAsChecked,
    handleNotification }) => {

    const dispatch = useDispatch();
    const { texts } = useSelector(state => state.translate);
    const { user } = useSelector(state => state.auth);

    const reject = () => {
        const submissionFeedbackInput = {
            id: submissionData.id,
            score: Number(0),
            scoreAdditionalData: JSON.stringify({
                weightedScore: 0,
                scoreType: 'numScore'
            }),
            remarks: feedback.remarks,
        }

        submissionsApi.submissionsRejectPost({ submissionFeedbackInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.submissionFeedbackSendError, error: error, statusCode: response?.statusCode, message: "callBackFunc " + error.message, level: 2, component: "SummativeAssessmentEdit", line: 77 }))
            }
            else {
                setSubmissionData({ ...submissionData, ...submissionFeedbackInput, submissionStatusId: resdata })
                markAssessmentAsChecked(submissionData.id);
                let textHe = "", textAr = "", textEn = "";
                setEditData(false)
                textHe = `${submissionData?.assessmentName} ${texts.submissionsRejectMessageHe} ${user.firstName} ${user.lastName}`
                textAr = `${submissionData?.assessmentName} ${texts.submissionsRejectMessageAr} ${user.firstName} ${user.lastName}`
                textEn = `${submissionData?.assessmentName} ${texts.submissionsRejectMessageEn} ${user.firstName} ${user.lastName}`
                handleNotification(textHe, textEn, textAr)
            }
        })
    }

    return (
        <>
            <RemarkEditor setRemarks={setRemarks} remarks={feedback.remarks} isGroup={submissionData.submittedByUser.isGroup} />
            <button className={classes.SubmitBtn}
                onClick={reject}
                tabIndex="0" role="button"
                onKeyDown={e => onKeyDown(e, reject)}
            >{texts.returnForRepair}</button>
        </>
    )
}
export default RejectEdit